// frontend/src/utils/country.js
//
// Country reference-data helpers.
//
// Centralises the lookup that defaults Supplier / Location forms to the
// store's country. Both `region_code` and `country_code` are alpha-2
// ISO 3166-1, so the lookup just confirms the country exists in the
// reference table before handing the code back as the form value.

export function defaultCountryFromStoreRegion(countries, regionCode) {
  if (!regionCode || !countries?.length) return null;
  const match = countries.find((c) => c.country_code === regionCode);
  return match?.country_code || null;
}
